"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class PortalCountriesConfig {
    constructor(partnerCountries, assuredCountries, landCargoCountries, portalCurrencies, taxesFromAPI) {
        this.partnerCountries = partnerCountries;
        this.assuredCountries = assuredCountries;
        this.landCargoCountries = landCargoCountries;
        this.portalCurrencies = portalCurrencies;
        this.taxesFromAPI = taxesFromAPI;
    }
    static fromObj(data) {
        var _a, _b, _c, _d, _e, _f;
        return new PortalCountriesConfig([...((_a = data === null || data === void 0 ? void 0 : data.partnerCountries) !== null && _a !== void 0 ? _a : [])], [...((_b = data === null || data === void 0 ? void 0 : data.assuredCountries) !== null && _b !== void 0 ? _b : [])], [...((_d = (_c = data === null || data === void 0 ? void 0 : data.landCargoCountries) !== null && _c !== void 0 ? _c : data === null || data === void 0 ? void 0 : data.assuredCountries) !== null && _d !== void 0 ? _d : [])], [...((_e = data === null || data === void 0 ? void 0 : data.portalCurrencies) !== null && _e !== void 0 ? _e : [])], [...((_f = data === null || data === void 0 ? void 0 : data.taxesFromAPI) !== null && _f !== void 0 ? _f : [])]);
    }
}
exports.default = PortalCountriesConfig;
//# sourceMappingURL=portalCountriesConfig.class.js.map